import { useState } from "react";

import * as Api from "@/api";
import Avatar from "@/design/components/Avatar";
import Valkyrie, { viSpinnerThird } from "@sippy-platform/valkyrie";

import { ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function Handsets({ provisioning, user, provisioningDispatch, currentAccountHandset, closeDrawer }) {
  const [pending, setPending] = useState(false);

  const handleAddAccount = () => {
    setPending(true);

    if (user.name) {
      Promise.resolve(
        Api.postProvisioningAccount(provisioning, {
          sippeer: user.username,
          handset: currentAccountHandset,
        }),
      )
        .then((response) =>
          provisioningDispatch({
            type: "addHandset",
            sippeer: user,
            handset: currentAccountHandset,
            id: response.data.account.id,
          }),
        )
        .finally(() => {
          setPending(false);
          closeDrawer();
        });
    }
  };

  return (
    <ListItem disablePadding sx={{ minHeight: 44 }}>
      <ListItemButton onClick={() => handleAddAccount(user)} disabled={pending} sx={{ minHeight: 44 }}>
        <ListItemAvatar sx={{ minWidth: 34 }}>
          <Avatar text={user.name} px={24} />
        </ListItemAvatar>
        <ListItemText primary={user.name} secondary={user.exten} />
        {pending && (
          <ListItemIcon sx={{ minWidth: 16 }}>
            <Valkyrie icon={viSpinnerThird} spin />
          </ListItemIcon>
        )}
      </ListItemButton>
    </ListItem>
  );
}

Handsets.propTypes = {
  provisioning: PropTypes.object,
  user: PropTypes.object,
  provisioningDispatch: PropTypes.func,
  currentAccountHandset: PropTypes.number,
  closeDrawer: PropTypes.func,
};

export default Handsets;
